<div class="d-lg-block d-none">
  <ng-container *notInPopulation="[populations.Kids]">
    <fgb-banner>
      <ng-template>
        <div class="d-flex flex-column gap-1 name-wrapper" routerLink="/account">
          <div class="d-flex align-items-center">
            <h1 class="font-heading fw-bold text-uppercase text-white mb-0 font-size-18 lh-1">
              {{ 'home.page.title' | translate }} {{ name$ | async }}
            </h1>
            <span class="material-symbols-outlined" > chevron_right </span>
          </div>
          <ng-container *ngIf="memberDetails$ | async as memberDetails">
            <div class="d-flex product-code font-size-14 text-white">
              {{ ('member.card.id' | translate) + ' : ' + memberDetails.ExternalRefNumber }}
            </div>
          </ng-container>
        </div>
      </ng-template>
    </fgb-banner>
  </ng-container>
  <ng-container *inPopulation="[populations.Kids]">
    <div class="img-banner-container" role="banner">
      <div class="container">
        <img [src]="'banner-images/kid-home-banner.png' | contentAssetImage" alt="kid banner" class="w-100" />
      </div>
    </div>
  </ng-container>
</div>
<ng-container *ifScreenSize="screenSize.Mobile">
  <fgb-mobile-nav-menu />
  <fgb-barcode></fgb-barcode>
  <div class="container kid-banner-image" *inPopulation="[populations.Kids]">
    <img [src]="'banner-images/kid-home-banner.png' | contentAssetImage" alt="home image" class="w-100" />
  </div>
  <fgb-home-nav />
</ng-container>
<div class="mobile-content-wrapper pt-lg-0 pt-3">
  <ng-container *notInPopulation="[populations.Kids]">
    <fgbcl-loyalty-feed-list />
  </ng-container>
  <div class="container">
    <ng-container *inProductCode="[productCode.STHs]">
      <div class="pt-lg-3">
        <fgb-upgrade-section />
      </div>
    </ng-container>
    <fgbcl-scorecard-carousel [icon]="'chevron_right'" [showAllView]="true"></fgbcl-scorecard-carousel>

    <fgb-vouchers></fgb-vouchers>
    <!-- Featured Rewards -->
    <fgbcl-featured-rewards [showAllPath]="'/rewards/raffles'"></fgbcl-featured-rewards>
    <ng-container *inPopulation="[populations.Kids]">
      <div class="d-none d-lg-block mt-3">
        <fgb-menu-carousel />
      </div>
    </ng-container>

    <!-- Announcements -->
    <fgbcl-announcements></fgbcl-announcements>
  </div>
</div>
